<template>
  <div class="exam-registration-wrapper" ref="wrapperRef">
    <div class="exam-registration" ref="contentRef">
      <HDFHeader03 />

    <div class="page-wrapper">
      <el-container>
        <el-header class="demo-header">
          <h1>考试报名信息填写</h1>
        </el-header>
        
        <el-main>
          <el-row>
            <el-col :span="3"></el-col>
            <el-col :span="18">
              <el-card class="registration-card">
                <template #header>
                  <div class="card-header">
                    <span>填写报名信息{{ '(' + title + ')' }}</span>
                  </div>
                </template>
                
                <div class="registration-content">
                  <el-form 
                    ref="registrationFormRef" 
                    :model="registrationForm" 
                    :rules="registrationRules"
                    label-width="150px"
                    class="registration-form">
                    
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="证件照片" prop="img">
                          <el-upload
                            class="avatar-uploader"
                            action="#"
                            :auto-upload="false"
                            :show-file-list="false"
                            :on-change="handleAvatarChange">
                            <img v-if="registrationForm.img" :src="registrationForm.img" class="avatar" />
                            <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
                          </el-upload>
                          <div class="upload-tip">
                            本人免冠证件照（红白蓝底皆可），小二寸（普通）照片尺寸：35mm*45mm，分辨率150像素，jpg格式。
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="考试类型" prop="type">
                          <el-select v-model="registrationForm.type" placeholder="请选择考试等级" @change="typeChange">
                            <el-option label="YAI" :value="'YAI'" />
                            <el-option label="YCL" :value="'YCL'" />
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="12">
                        <el-form-item label="考试等级" prop="levelId">
                          <el-select v-model="levelId" placeholder="请选择考试等级" @change="levelChange">
                            <el-option v-for="item in typeLevel[registrationForm.type]" :key="item.id" :label="item.lable" :value="item.id" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      
                      <!-- <el-col :span="12">
                        <el-form-item label="编程语言" prop="lang">
                          <el-select v-model="registrationForm.lang" placeholder="请选择编程语言">
                            <el-option label="scratch" value="scratch" />
                            <el-option label="python" value="python" />
                            <el-option label="c++" value="c++" />
                          </el-select>
                        </el-form-item>
                      </el-col> -->

                      <el-col :span="12">
                        <el-form-item label="省级" prop="province">
                          <el-input v-model="registrationForm.province" placeholder="请输入省级信息，例如：广东省" />
                        </el-form-item>
                      </el-col>
                      
                      <el-col :span="12">
                        <el-form-item label="市级" prop="city">
                          <el-input v-model="registrationForm.city" placeholder="请输入市级信息，例如：江门市" />
                        </el-form-item>
                      </el-col>

                      <el-col :span="12">
                        <el-form-item label="考生姓名" prop="name">
                          <el-input v-model="registrationForm.name" placeholder="请输入考生姓名" />
                        </el-form-item>
                      </el-col>
                      
                      <el-col :span="12">
                        <el-form-item label="考生性别" prop="sex">
                          <el-select v-model="registrationForm.sex" placeholder="请选择性别">
                            <el-option label="男" value="男" />
                            <el-option label="女" value="女" />
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="12">
                        <el-form-item label="手机号码" prop="telephone">
                          <el-input v-model="registrationForm.telephone" placeholder="请输入手机号码" />
                        </el-form-item>
                      </el-col>

                      <el-col :span="12">
                        <el-form-item label="参加培训机构" prop="groupId">
                          <el-select v-model="registrationForm.groupId" placeholder="请选择培训机构">
                            <el-option label="童程童美" :value="4" />
                            <el-option label="小码精灵" :value="6" />
                            <el-option label="学而思" :value="7" />
                            <el-option label="测试模拟" :value="8" />
                            <el-option label="核桃编程" :value="9" />
                            <el-option label="其它培训机构" :value="-2" />
                            <el-option label="未参加培训机构" :value="-4" />
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <!-- <el-col :span="12">
                        <el-form-item label="考试期次" prop="areaId">
                          <el-select v-model="registrationForm.areaId" placeholder="请选择考试期次">
                            <el-option label="第一期" :value="'1'" />
                            <el-option label="第二期" :value="'2'" />
                            <el-option label="第三期" :value="'3'" />
                          </el-select>
                        </el-form-item>
                      </el-col> -->
                      
                      <el-col :span="12">
                        <el-form-item label="证件类型" prop="identityType">
                          <el-select v-model="registrationForm.identityType" placeholder="请选择证件类型">
                            <el-option label="大陆身份证" :value="1" />
                            <el-option label="香港身份证" :value="2" />
                            <el-option label="澳门身份证" :value="3" />
                            <el-option label="台湾身份证" :value="4" />
                            <el-option label="港澳通行证" :value="6" />
                            <el-option label="护照" :value="5" />
                            <el-option label="其他" :value="7" />
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="12">
                        <el-form-item label="证件号码" prop="identity">
                          <el-input v-model="registrationForm.identity" placeholder="请输入证件号码" />
                        </el-form-item>
                      </el-col>
                      
                      <el-col :span="12">
                        <el-form-item label="证书获取方式" prop="postWay">
                          <el-select v-model="registrationForm.postWay" placeholder="请选择证书获取方式">
                            <el-option label="由机构老师代领" value="1" />
                            <el-option label="快递" value="2" />
                            <el-option label="不要纸质证书" value="3" />
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="24" v-if="registrationForm.postWay == '2'">
                        <el-form-item label="证书邮寄地址" prop="postAddress">
                          <el-input v-model="registrationForm.postAddress" placeholder="请输入证书邮寄地址 XX省XX市XX区(县)+详细地址" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="紧急联系人" prop="emergencyContactName">
                          <el-input v-model="registrationForm.emergencyContactName" placeholder="请输入紧急联系人" />
                        </el-form-item>
                      </el-col>
                      
                      <el-col :span="12">
                        <el-form-item label="紧急联系人电话" prop="emergencyContactPhone">
                          <el-input v-model="registrationForm.emergencyContactPhone" placeholder="请输入紧急联系人电话" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="学校" prop="schoolName">
                          <el-input v-model="registrationForm.schoolName" placeholder="请输入学校名称（选填）" />
                        </el-form-item>
                      </el-col>
                      
                      <el-col :span="12">
                        <el-form-item :label="'参加的培训班'" prop="trainingInstitution">
                          <el-input v-model="registrationForm.trainingInstitution" placeholder="如无参加培训班请填“无”" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="是否开发票" prop="bill">
                          <el-select v-model="registrationForm.bill" placeholder="请选择是否开发票">
                            <el-option label="不需要" value="不开" />
                            <el-option label="开具个人发票" value="个人" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      
                      <el-col :span="12">
                        <el-form-item 
                          label="电子邮箱" 
                          prop="billAddress"
                          v-if="registrationForm.bill === '个人'">
                          <el-input v-model="registrationForm.billAddress" placeholder="请输入电子邮箱" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-form-item>
                      <el-button type="primary" @click="submitForm">提交报名信息</el-button>
                      <el-button @click="resetForm">重置</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </el-card>
            </el-col>
            <el-col :span="3"></el-col>
          </el-row>
        </el-main>
      </el-container>
    </div>

    <HDFFooter03 />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import { apiSubmitExamInfo, apiUploadAvatar } from '@/api/exam'

import HDFHeader03 from '@/components/HDFHeader03.vue'
import HDFFooter03 from '@/components/HDFFooter03.vue'

// ===================== 等比例缩放逻辑 =====================
const wrapperRef = ref(null)
const contentRef = ref(null)
const MAX_WIDTH = 1920 // 界面最大宽度
const SCALE_WIDTH = 1920 // 缩放基准宽度

const updateScale = () => {
  if (!wrapperRef.value || !contentRef.value) return
  
  const screenWidth = window.innerWidth
  
  if (screenWidth < SCALE_WIDTH) {
    // 小于1920px时进行等比例缩放
    const scale = screenWidth / SCALE_WIDTH
    
    // 设置容器高度为缩放后的实际高度
    const contentHeight = contentRef.value.scrollHeight
    wrapperRef.value.style.height = `${contentHeight * scale}px`
    
    // 应用缩放
    contentRef.value.style.transform = `scale(${scale})`
    contentRef.value.style.transformOrigin = 'top left'
    contentRef.value.style.margin = '0'
  } else {
    // 大于等于1920px时保持原始大小并居中
    wrapperRef.value.style.height = 'auto'
    contentRef.value.style.transform = 'none'
    contentRef.value.style.margin = '0 auto'
  }
}

onMounted(() => {
  updateScale()
  window.addEventListener('resize', updateScale)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScale)
})

const router = useRouter()

const registrationFormRef = ref()
const registrationForm = reactive({
  img: '',
  sessionId: null,
  type: null,
  levelId: null,
  level: null,
  lang: '无',
  groupId: null,
  areaId: null,
  province: '',
  city: '',
  name: '',
  sex: '',
  telephone: '',
  identityType: null,
  identity: '',
  postWay: '',
  postAddress: '',
  schoolName: '',
  trainingInstitution: '',
  emergencyContactName: '',
  emergencyContactPhone: '',
  bill: '不开',
  billAddress: ''
})

const title = ref('报名信息')
// 从url中获取areaId和titile参数
const queryParam = getQueryParams()
title.value = queryParam.title
registrationForm.sessionId = queryParam.id

//实现getQueryParams方法
function getQueryParams() {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  const params = {}
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    //需要解决url解码问题
    params[pair[0]] = decodeURIComponent(pair[1])
  }
  return params
}

const typeChange = () => {
  levelId.value = null;
  registrationForm.levelId = null;
  registrationForm.level = null;
  registrationForm.lang = '无'
}

const validatePhone = (rule, value, callback) => {
  const phoneRegex = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  if (!value) {
    callback(new Error('请输入手机号码'))
  } else if (!phoneRegex.test(value)) {
    callback(new Error('手机号码格式不正确'))
  } else {
    callback()
  }
}

const validatePostAddress = (rule, value, callback) => {
  if(registrationForm.postWay == '2'){
    if (!value) {
      callback(new Error('请输入证书邮寄地址'))
    } else{
      callback()
    }
  }else{
    callback()
  }
}

const levelId = ref(null)


const typeLevel = ref({
    'YAI': [
      {id: 0, levelId: 'yai-01', key: '一级', lable: '一级（考试材料需自备）'},
      {id: 1, levelId: 'yai-02', key: '二级', lable: '二级（考试材料需自备）'}, 
      {id: 2, levelId: 'yai-03', key: '三级', lable: '三级（参加四五六级前必考，考试材料需自备）'},
      {id: 3, levelId: 'yai-04', key: '四级', lable: '四级（考试材料需自备）'},
      {id: 4, levelId: 'yai-05', key: '五级', lable: '五级（考试材料需自备）'},
      {id: 5, levelId: 'yai-06', key: '六级', lable: '六级（考试材料需自备）'}
    ],
    'YCL': [
      {id: 0, levelId: 'ycl-01', key: '一级', lable: '一级（scratch）'},
      {id: 1, levelId: 'ycl-02', key: '二级', lable: '二级（scratch）'}, 
      {id: 2, levelId: 'ycl-03', key: '三级', lable: '三级（scratch）'},
      {id: 3, levelId: 'ycl-0401', key: '四级', lable: '四级（python参加五六级前必考）'},
      {id: 4, levelId: 'ycl-0402', key: '四级', lable: '四级（C++参加五六级前必考）'},
      {id: 5, levelId: 'ycl-0501', key: '五级', lable: '五级（python）'},
      {id: 6, levelId: 'ycl-0502', key: '五级', lable: '五级（C++）'},
      {id: 7, levelId: 'ycl-0601', key: '六级', lable: '六级（python）'},
      {id: 8, levelId: 'ycl-0602', key: '六级', lable: '六级（C++）'}
    ]
  })

const levelChange = (id) => {
  const levelItem = typeLevel.value[registrationForm.type][id]
  registrationForm.levelId = levelItem.levelId;
  registrationForm.level = levelItem.key;
  registrationForm.lang = '无'
  if(registrationForm.type == 'YCL'){
    switch(id){
      case 0:
      case 1:
      case 2:
        registrationForm.lang = 'scratch'
        break;
      case 3:
      case 5:
      case 7:
        registrationForm.lang = 'python'
        break;
      case 4:
      case 6:
      case 8:
        registrationForm.lang = 'c++'
        break;
    }
  }
  console.log(registrationForm)
}


const validateIdentity = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入证件号码'))
    return
  }

  let regex
  switch (registrationForm.identityType) {
    case 1: // 大陆身份证
      regex = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/
      break
    case 2: // 香港身份证
      regex = /[A-Z]{1,2}[0-9]{6}\([0-9A]\)/
      break
    case 3: // 澳门身份证
      regex = /^[1|5|7][0-9]{6}\([0-9Aa]\)/
      break
    case 4: // 台湾身份证
      regex = /[A-Z][0-9]{9}/
      break
    case 5: // 护照
      regex = /^[a-zA-Z0-9]{3,21}$/
      break
    case 6: // 港澳通行证
      regex = /[A-Z][0-9]{8}/
      break
    case 7: // 其他
      callback() // 无校验规则
      return
    default:
      callback(new Error('请选择证件类型'))
      return
  }

  if (!regex.test(value)) {
    callback(new Error('证件号码格式不正确'))
  } else {
    // 对于大陆身份证，还需要验证年龄不能超过18岁
    if (registrationForm.identityType === 1) {
      const birthYear = parseInt(value.substring(6, 10))
      const currentYear = new Date().getFullYear()
      if (currentYear - birthYear > 18) {
        callback(new Error('年龄不能超过18岁'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }
}

const registrationRules = {
  img: [
    { required: true, message: '请上传证件照片', trigger: 'change' }
  ],
  type: [
    { required: true, message: '请选择考试类型', trigger: 'change' }
  ],
  levelId: [
    { required: true, message: '请选择考试等级', trigger: 'change' }
  ],
  lang: [
    { required: true, message: '请选择编程语言', trigger: 'change' }
  ],
  groupId: [
    { required: true, message: '请选择培训机构', trigger: 'change' }
  ],
  province: [
    { required: true, message: '请输入省级信息', trigger: 'blur' }
  ],
  city: [
    { required: true, message: '请输入市级信息', trigger: 'blur' }
  ],
  name: [
    { required: true, message: '请输入考生姓名', trigger: 'blur' }
  ],
  sex: [
    { required: true, message: '请选择考生性别', trigger: 'change' }
  ],
  telephone: [
    { required: true, validator: validatePhone, trigger: 'blur' }
  ],
  identityType: [
    { required: true, message: '请选择证件类型', trigger: 'change' }
  ],
  identity: [
    { required: true, validator: validateIdentity, trigger: 'blur' }
  ],
  postWay: [
    { required: true, message: '请选择证书获取方式', trigger: 'change' }
  ],
  postAddress: [
    // { required: true, message: '请输入证书邮寄地址', trigger: 'blur' }
    { required: true, validator: validatePostAddress, trigger: 'blur' }
  ],
  trainingInstitution: [
    { required: true, message: '如无参加培训班请填“无”', trigger: 'blur' }
  ],
  emergencyContactName: [
    { required: true, message: '请输入紧急联系人', trigger: 'blur' }
  ],
  emergencyContactPhone: [
    { required: true, validator: validatePhone, trigger: 'blur' }
  ],
  bill: [
    { required: true, message: '请选择是否开发票', trigger: 'change' }
  ],
  billAddress: [
    { required: true, message: '请输入电子邮箱', trigger: 'blur' }
  ]
}

const handleAvatarChange = (file) => {

  console.log(file)

  const formData = new FormData()
  formData.append('file', file.raw)
  apiUploadAvatar(formData).then(response => { 
    const res = response.data
    if (res.code === 200) {
      ElMessage.success('上传成功！')
      registrationForm.img = res.data
    } else {
      ElMessage.error(res.msg)
    }
  })
}

const submitForm = () => {
  registrationFormRef.value.validate((valid) => {
    if (valid) {
      // 这里可以添加跳转到状态页面的逻辑
      apiSubmitExamInfo(registrationForm).then(response => {
        const res = response.data
        if (res.code === 200) {
          ElMessage.success('报名信息提交成功！')
          router.push({
            path: '/exam-status',
            query: {
              id: queryParam.id
            }
          })
        } else {
          ElMessage.error(res.msg)
        }
      })
    } else {
      ElMessage.error('请检查填写的信息是否正确')
      return false
    }
  })
}

const resetForm = () => {
  registrationFormRef.value.resetFields()
}
</script>

<style scoped>
.exam-registration-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.exam-registration {
  width: 1920px;
  min-height: 100vh;
  background-color: #f5f7fa;
  transform-origin: top left;
}

.page-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.demo-header h1 {
  text-align: center;
  margin: 20px 0;
}

.registration-card {
  margin-bottom: 20px;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}

@media (max-width: 768px) {
  .page-wrapper {
    padding: 0 10px;
  }
}
.el-form-item__label {
  white-space: pre-line;
}
</style>